import {isTimeRegistrationTimeInvalidWithReason} from './TimeRegistrationTimeFilter';
import {isExceedingEstimateAllowed} from '../../cache/TimeRegistrationSettingsUtil';
import Util from '../../util';
import {IntlShape} from 'react-intl';

export function getRemainingTimeInfoMessage(
	remainingMinutes: number | null,
	estimateForecastMinutes: number | null,
	intl: IntlShape
): string | null {
	if (isExceedingEstimateAllowed() || estimateForecastMinutes === null || isNaN(estimateForecastMinutes)) {
		return null;
	}
	const remainingTime = remainingMinutes !== null ? Util.convertMinutesToFullHour(remainingMinutes, intl) : null;
	const estimatedTime = Util.convertMinutesToFullHour(estimateForecastMinutes, intl);
	return remainingTime && estimatedTime ? `${remainingTime} remaining of ${estimatedTime} estimate` : null;
}

export function useTaskEstimateValidation(
	estimateForecastMinutes: number | null | undefined,
	totalMinutesRegistered: number | null | undefined,
	initialMinutes: number | null | undefined,
	intl: IntlShape
): {remainingInfoMessage: string | null; validateTimeInputValue: (timeInputValue) => string | null} {
	if (
		isExceedingEstimateAllowed() ||
		estimateForecastMinutes === null ||
		estimateForecastMinutes === undefined ||
		isNaN(estimateForecastMinutes)
	) {
		return {
			remainingInfoMessage: null,
			validateTimeInputValue: () => {
				return null;
			},
		};
	}
	const remainingMinutes = estimateForecastMinutes - (totalMinutesRegistered || 0) + (initialMinutes || 0);

	function validateTimeInputValue(timeInputValue): string | null {
		return isTimeRegistrationTimeInvalidWithReason({
			inputMinutes: timeInputValue || 0,
			remainingMinutes: remainingMinutes === undefined ? null : remainingMinutes,
			subtractMinutes: 0,
		});
	}
	const remainingInfoMessage = getRemainingTimeInfoMessage(remainingMinutes, estimateForecastMinutes, intl);
	return {remainingInfoMessage, validateTimeInputValue};
}

export function getTotalMinutesRegisteredFromTimeRegistrationEdges(edges: [{node: {minutesRegistered}}]): number | null {
	if (isExceedingEstimateAllowed() || !edges) {
		return null;
	}
	return edges.reduce((sum, timeRegistration) => {
		return sum + timeRegistration.node.minutesRegistered;
	}, 0);
}
